import { render, staticRenderFns } from "./AddClinic.vue?vue&type=template&id=2d88c035&scoped=true"
import script from "./AddClinic.vue?vue&type=script&lang=js"
export * from "./AddClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88c035",
  null
  
)

export default component.exports